import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const TrailerType = ({ roles }) => {

    return (
        <M_Table entityName={'TrailerType'} filtersOnTable rolePermissions={roles} />
    )
}